export function copy(str: string) {
  // eslint-disable-next-line compat/compat
  return navigator.clipboard.writeText(str);
}
